import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import globals from '../../globals'
import animations from './animations'
import NavItem from '../NavItem'
import Logo from '../../components/Logo'
import CustomLink from '../../components/CustomLink'
import store from '../../store'
import { connect } from 'react-redux'

class NavMobile extends Component {
    constructor (props) {
        super(props)

        this.state = {
            navItems: []
        }
    }

    componentDidMount () {
        animations.initialise(this)
        this.setState({
            navItems: { ...this.props.items }
        })
    }

    componentDidUpdate (prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                navItems: { ...this.props.items }
            })
        }
    }

    handleClick (event) {
        animations.handleHamburgerClick(event, this)
    }

    handlePageChange () {
        animations.handlePageChange(this)
    }

    render () {
        const MainItems = Object.keys(this.state.navItems).map((key, index) => {
            const item = this.state.navItems[key]
            return (
                <NavItem
                    key={key}
                    identifier={key}
                    title={item.title}
                    url={item.url}
                    active={item.active}
                    children={item.children}
                    handleShowSubNav={animations.animateSubNavIn.bind(this)}
                    handlePageChange={this.handlePageChange.bind(this)}
                />
            )
        })

        const SubItems = Object.keys(this.state.navItems).map((key, index) => {
            const item = this.state.navItems[key]
            if (item.children.length === 0) { return }

            const SubItem = item.children.map((child) => {
                if (this.props.residential && item.residentialOnly || !item.residentialOnly) {
                    return (
                        <li key={globals.convertToSlug(child.title)}>
                            <CustomLink
                                to={child.url}
                                className={`${child.active} gtm-site-nav-click`}
                                dangerouslySetInnerHTML={{ __html: child.title }}
                                onClick={this.handlePageChange.bind(this)}
                            />
                        </li>
                    )
                }
            })

            return (
                <ul key={key} className={key + ' subnav-mobile'}>
                    {SubItem}
                </ul>
            )
        })

        return (
            <div className='nav-mobile'>
                <div className='bg-slidedown-animated' />
                <div className='bg-mask' />
                <Logo />
                <div className='mobile hamburger' onClick={this.handleClick.bind(this)} ref={(el) => this.hamburgerRef = el}>
                    <span />
                    <span />
                    <span />
                    <span />
                </div>
                <div className='nav-inner'>
                    <div className='bg-placeholder'>
                        <div className='subnav-heading' onClick={animations.animateSubNavOut.bind(this)} />
                    </div>
                    <ul className='main-nav'>
                        {MainItems}
                    </ul>
                    {SubItems}
                    <div className='get-in-touch text-center'>
                        <div className='buttons'>
                            <p>{store.getState().auth.fullName}</p>
                            <Link to='/logout' onClick={this.handlePageChange.bind(this)}>
                                <img src='/images/btn-logout-mobile.svg' alt='Logout' />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}

const mapStateToProps = state => ({
    residential: state.auth.residential
})

export default connect(mapStateToProps, {})(NavMobile)



// WEBPACK FOOTER //
// ./resources/js/layout/NavMobile/NavMobile.js